var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-12 border-r h-screen fixed left-0 z-10 left-bar_js",class:[ _vm.wrapBg, _vm.rightBlockBorderColor ]},[_vm._t("discoveryProcess"),_c('div',{staticClass:"w-12 h-12 border-b",class:[ _vm.topBlockBorderColor ]}),_c('div',{staticClass:"w-12 h-12 border-b",class:[ _vm.bottomBlockBorderColor ]}),(_vm.$route.matched.some(function (ref) {
	var name = ref.name;

	return name === 'Search';
}))?_c('scroll-bar'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }